import { buildApiUrl } from '../config';
import useAPI from '../../hooks/useAPI';
import { useState } from 'react';
import { z } from 'zod';

// Import existing types to use in function signatures
import { EmploymentSchedule } from '../../types/backendResponses/EmploymentSchedule';

// Create Zod schema for EmploymentSchedule
const EmploymentScheduleSchema = z.object({
  employmentSchedule: z.array(z.any()).nullable().optional(), // EmploymentScheduleDay array
  name: z.string(),
  id: z.string(),
  hoursPerWeek: z.number().nullable().optional(),
});

/**
 * Hook for getting all employment schedules with built-in state management
 * Includes Zod validation for type safety
 */
export const useGetEmploymentSchedules = () => {
  const { callAPI } = useAPI(); // GET

  const [data, setData] = useState<EmploymentSchedule[] | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<any>(null);

  /**
   * Get all employment schedules
   * @returns Promise with boolean indicating success
   */
  const action = async (): Promise<boolean> => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await callAPI(buildApiUrl('employmentSchedule'));

      // Validate the response data
      const validatedData = /* z
        .array(EmploymentScheduleSchema)
        .parse(*/ response /* ) */ as EmploymentSchedule[];

      setData(validatedData);
      return true;
    } catch (error) {
      console.error('Error in useGetEmploymentSchedules:', error);
      setError(error);
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isLoading,
    error,
    action,
  };
};
